<template>
    <div
        class="AlgoliaSearchSubcategories bg--grey-light hide--palm"
    >
        <ul
            v-if="items"
            class="container"
        >
            <li
                v-for="item in items"
                :key="item.value"
                :class="{'is-disabled' : item.count === 0, 'is-refined' : item.isRefined}"
            >
                <button
                    @click="refine(item.value)"
                    class="SearchFilter"
                >
                    <strong
                        class="mr-min"
                    >
                        {{ item.label }}
                    </strong>
                    {{ item.count }}
                </button>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'AlgoliaSearchSubcategories',
    props: {
        items: {
            type: Array
        },
        refine: {
            type: Function
        },
    }
}
</script>
<style lang="scss" scoped>

    .AlgoliaSearchSubcategories {
        @include media-query(lap-and-up) {
            height: 60px;
        }
    }

    .SearchFilter {
        border-radius: 50px;
        font-size: 14px;
        padding: 6px 15px;
        background: transparent;

        strong {
            color: $action-color;

            .is-refined & {
                color: getColor('white');
            }
        }

        .is-refined & {
            color: getColor('white');
            background: getColor('sand', 'dark');
        }
    }

     ul {
        display: flex;
        align-items: center;
        height: 100%;
    }
</style>
